import { render, staticRenderFns } from "./DefaultGridIcon.vue?vue&type=template&id=6efed36c&"
import script from "./DefaultGridIcon.vue?vue&type=script&lang=js&"
export * from "./DefaultGridIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports